import React, { type ReactNode } from 'react';

import { motion } from 'framer-motion';

export type AuthPanelStepProps = {
    children: ReactNode;
};

const DEFAULT_TRANSITION = {
    type: 'spring',
    mass: 0.5,
    damping: 150,
    stiffness: 1000,
};

export function AuthPanelStep({ children }: AuthPanelStepProps) {
    return (
        <motion.div
            style={{
                minWidth: '100%',
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
            }}
            initial={{ opacity: 0, translateX: '25%' }}
            animate={{ opacity: 1, translateX: '0%', transition: { ...DEFAULT_TRANSITION, delay: 0.2 } }}
            exit={{
                opacity: 0,
                translateX: '-25%',
            }}
            transition={DEFAULT_TRANSITION}
        >
            {children}
        </motion.div>
    );
}
